"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Underground = Underground;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _FromUndergroundTime = require("./parts/FromUndergroundTime");
var _UndergroundIcon = require("./parts/UndergroundIcon");
var styles = _interopRequireWildcard(require("./styles.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function Underground(_ref) {
  let {
    lineColor,
    name,
    transportType,
    undergroundType,
    timeDisplay
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['underground'],
    "data-testid": "underground"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['underground-station']
  }, lineColor && /*#__PURE__*/React.createElement(_UndergroundIcon.UndergroundIcon, {
    lineColor: lineColor,
    undergroundType: undergroundType
  }), /*#__PURE__*/React.createElement(_uiKit.UIText2, null, name)), transportType && /*#__PURE__*/React.createElement(_FromUndergroundTime.FromUndergroundTime, {
    transportType: transportType,
    timeTo: timeDisplay
  }));
}